import { Phone, Mail, MessageCircle } from 'lucide-react';
import BusinessHours from './BusinessHours';
import config from '@/lib/config';

const ContactInfo = () => {
  const contactInfo = [
    {
      icon: Mail,
      title: 'Email',
      info: config.contact.email,
      link: `mailto:${config.contact.email}`,
      gradient: 'from-orange-500 to-amber-500',
    },
    {
      icon: Phone,
      title: 'Call',
      info: config.contact.phone,
      link: `tel:${config.contact.phone}`,
      gradient: 'from-emerald-500 to-teal-500',
    },
    {
      icon: MessageCircle,
      title: 'WhatsApp',
      info: config.contact.phone,
      link: `https://wa.me/${config.contact.phoneRaw}`,
      gradient: 'from-green-500 to-emerald-500',
    },
    // {
    //   icon: MapPin,
    //   title: 'Location',
    //   info: 'Foodville, FC 12345',
    //   link: 'https://maps.google.com/?q=Foodville, FC 12345',
    //   gradient: 'from-violet-500 to-purple-500',
    // },
  ];

  const socialLinks = [
    {
      name: 'Instagram',
      url: config.socials.instagram.url,
      color: 'bg-gradient-to-r from-pink-500 to-rose-500',
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-4 h-4 mr-1"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="M7.75 2h8.5A5.75 5.75 0 0122 7.75v8.5A5.75 5.75 0 0116.25 22h-8.5A5.75 5.75 0 012 16.25v-8.5A5.75 5.75 0 017.75 2z"
          />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M16 8h.01" />
          <circle cx="12" cy="12" r="3.5" />
        </svg>
      ),
    },
    // {
    //   name: 'Facebook',
    //   url: config.socials.facebook.url,
    //   color: 'from-blue-500 to-indigo-500',
    //   icon: (
    //     <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 mr-1" viewBox="0 0 24 24" fill="currentColor">
    //       <path d="M22 12a10 10 0 10-11.63 9.87v-6.99H8.1V12h2.27V9.8c0-2.24 1.33-3.48 3.38-3.48.98 0 2.01.17 2.01.17v2.2h-1.13c-1.12 0-1.47.7-1.47 1.42V12h2.5l-.4 2.88h-2.1v6.99A10 10 0 0022 12z" />
    //     </svg>
    //   ),
    // },
    {
      name: 'TikTok',
      url: config.socials.tiktok.url,
      color: 'bg-black',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 mr-1" width="600" height="600" viewBox="0 0 600 600">
          <title>TikTok</title>
          <g id="BACKGROUND">
            <circle cx="300" cy="300" r="300" />
          </g>
          <g id="ICONS">
            <path
              d="M260.18,257.1V240.82a123.43,123.43,0,0,0-87.44,223.47A123.46,123.46,0,0,1,260.18,257.1Z"
              fill="#25f4ee"
            />
            <path
              d="M263.09,436.94c30.4,0,55.54-24.52,56.67-54.64L320,113.71l48.7,0-.07-.41a92.76,92.76,0,0,1-1.59-17H300l-.11,269a56.29,56.29,0,0,1-82.48,47.81C227.62,427.29,244.27,436.94,263.09,436.94Z"
              fill="#25f4ee"
            />
            <path
              d="M460.44,205.42V189.66a92.77,92.77,0,0,1-50.85-15.12C422.63,189.52,440.34,201.12,460.44,205.42Z"
              fill="#25f4ee"
            />
            <path d="M409.59,174.54a92.9,92.9,0,0,1-23-61.22H368.34A94,94,0,0,0,409.59,174.54Z" fill="#fe2c55" />
            <path
              d="M243.53,306.21c-31.11,0-56.79,25.83-56.79,56.93,0,21.67,12.66,40.49,30.62,49.94a56.32,56.32,0,0,1,45.73-89.32,55.25,55.25,0,0,1,16.65,2.61V257.85a123.46,123.46,0,0,0-16.65-1.21c-1,0-1.94.05-2.91.08h-.26l-.18,51.86A52.61,52.61,0,0,0,243.53,306.21Z"
              fill="#fe2c55"
            />
            <path
              d="M460.44,204.62l-.32-.06v51.82A160.17,160.17,0,0,1,366.65,226l0,137.11A123.51,123.51,0,0,1,172.74,464.29a123.45,123.45,0,0,0,213.89-84.11V243.78a159.56,159.56,0,0,0,93.37,30V206.7A93.39,93.39,0,0,1,460.44,204.62Z"
              fill="#fe2c55"
            />
            <path
              d="M367.06,363.14V226.75a159.61,159.61,0,0,0,93.38,30V204.62a93.45,93.45,0,0,1-50.85-30.08,93.51,93.51,0,0,1-40.94-61.22H319.51l-.11,269a56.31,56.31,0,0,1-102,30.78,56.39,56.39,0,0,1,26.17-106.35,55.56,55.56,0,0,1,16.65,2.6V256.72C193.41,258.28,139.56,313,139.56,380.18a123.05,123.05,0,0,0,33.18,84.11A123.43,123.43,0,0,0,367.06,363.14Z"
              fill="#fff"
            />
          </g>
        </svg>
      ),
    },
  ];

  return (
    <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg p-6 border border-white/50">
      <h3 className="text-lg font-semibold text-gray-800 mb-6 text-center">Get in Touch</h3>

      {/* Compact Contact Grid */}
      <div className="flex flex-col space-y-10 mb-6">
        {contactInfo.map((info, index) => (
          <a
            key={index}
            href={info.link}
            target="_blank"
            rel="noopener noreferrer"
            className="group cursor-pointer no-underline">
            <div className="flex items-center gap-3 rounded-xl bg-gradient-to-br from-white/60 to-white/30 hover:from-white/80 hover:to-white/50 transition-all duration-300 border border-white/30">
              <div
                className={`w-10 h-10 bg-gradient-to-br ${info.gradient} rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-md`}>
                <info.icon className="w-5 h-5 text-white" />
              </div>
              <div>
                <h4 className="font-medium text-gray-800 text-sm mb-1">{info.title}</h4>
                <p className="text-gray-600 text-xs leading-tight">{info.info}</p>
              </div>
            </div>
          </a>
        ))}
      </div>

      {/* Compact Social Links */}
      <div className="border-t border-gray-200/50 pt-4 relative">
        <p className="text-sm font-medium text-gray-700 mb-3 text-center flex items-center justify-center gap-1">
          <svg className="w-4 h-4 text-pink-500 animate-pulse" fill="currentColor" viewBox="0 0 20 20">
            <path d="M10 15l-5.878 3.09 1.122-6.545L.487 6.91l6.561-.955L10 0l2.952 5.955 6.561.955-4.757 4.635 1.122 6.545z" />
          </svg>
          Follow Us
        </p>

        <div className="flex gap-2">
          {socialLinks.map((social) => (
            <a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`flex items-center justify-center gap-1 flex-1 ${social.color} text-white py-2 px-3 rounded-lg text-xs font-medium transition-all transform duration-200 hover:scale-105 active:scale-95 shadow-md hover:shadow-lg`}>
              {social.icon}
              {social.name}
            </a>
          ))}
        </div>
      </div>

      {/* Business Hours */}
      <BusinessHours />
    </div>
  );
};

export default ContactInfo;
